














































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import { DxNumberBox } from 'devextreme-vue/number-box';
import DxButton from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import DxList from 'devextreme-vue/list';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxSortable } from 'devextreme-vue/sortable';
import ArrayStore from 'devextreme/data/array_store';
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxItem,
} from 'devextreme-vue/form';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    AuthServiceContract,
    SignInType,
    DialogButton,
    WindowsServiceContract,
    SettingsChangeServiceContract,
    SettingsChangeServiceData,
    ClientSettingsChangeServiceData,
    OffsetsBlockSettingsChangeServiceData,
    ChangedSetting,
    SaveSettingsRequestModel,
    ResetSettingsModel,
} from '@/core/contracts';
import { IndicatorsState } from '@/store/index';
import { copyToClipboard, NoCache } from '@/core/helpers';
import {
    User,
    ClientSettingTypeEnum,
    Role,
    ContextUser,
    ContextSettings,
    ClientSettings,
    OffsetsBlockSettings,
} from '@/dto';
import { ContextsState, SettingsState, UserState } from '@/store';
import IndicatorsModule, {
    Indicator,
    IndicatorState,
} from '@/store/indicators';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxSelectBox } from 'devextreme-vue';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import { IndicatorItem } from './UserSettings.IndicatorItem';
import { UserManager } from 'oidc-client';
import { getTableCaption } from '@/core/components/table/tableHelpers';

interface IClientSetting {
    id: number;
    name: string;
    expanded: boolean;
    parentId?: number;
    value?: number;
    disabled: boolean;
}

interface IUserModel {
    id: number;
    name: string;
    role: Role;
}

interface IGlobalTable {
    key: string;
    name: string;
    type?: string;
}

interface IContextSettingsModel {
    contextType: string;
    currentTime: string;
    scheduleTime: string;
    settings: { [key: string]: string };
}

@Component({
    components: {
        DxNumberBox,
        DxForm,
        DxSimpleItem,
        DxGroupItem,
        DxLabel,
        DxItem,
        DxList,
        DxButton,
        DxSelectBox,
        DxDropDownBox,
        DxTreeView,
        DxScrollView,
        DxSortable,
    },
})
export default class UserSettingsComponent extends Vue {
    private isAdmin: boolean = false;
    private inLoading: boolean = true;
    private isDropDownBoxOpened: boolean = false;
    private currentContextUser!: ContextUser;
    private listUsers: Array<IUserModel> = [];
    private listRoles: Array<Role> = [];
    private selectedUserId: number = 0;
    private selectedRoleId: number | undefined = 0;
    private localFilter: string = '';
    private filterIndicatorsDebounced = debounce(this.filterIndicators, 250);
    private indicators: IndicatorItem[] = [];
    private filteredIndicators: IndicatorItem[] = [];
    private selectedIndicators: IndicatorItem[] = [];
    private clientSettingId: number = 0;
    private clientSettingType: number = -1;
    private localData!: SettingsChangeServiceData;
    private listTableStores: Array<IGlobalTable> = [];

    private _isDisabled: boolean = true;
    private clientSettings: Array<IClientSetting> = [];

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    private get localize() {
        return localize;
    }

    private async created(): Promise<void> {
        this.isAdmin = ContextsState.current!.own === true;
        await this.loadSettingsLevel();
    }

    private async mounted() {
        if (this.isAdmin) {
            await this.loadUsers();
            await this.setCurrentContextUser();
            await this.loadRoles();
            if (!this.currentContextUser.role) {
                const finedRole = this.listRoles.find(
                    s => s.name === 'Administrator'
                );
                this.selectedRoleId = finedRole ? finedRole.id : -1;
            } else {
                this.selectedRoleId = this.currentContextUser.role
                    ? this.currentContextUser.role.id
                    : -1;
            }
        } else {
            await this.setCurrentContextUser();
        }

        this.selectedUserId = Number(UserState.current!.id);

        await this.loadData();

        this.inLoading = false;
    }

    private async saveOnClick(e: any) {
        const saveResult = await this.saveData();

        if (saveResult) {
            notify(
                this.$l.UserSettingsPage.UserSettingsComponent.ResultSuccess,
                'success',
                3000
            );
            await SettingsState.fetchSettings();
            IndicatorsState.fetchIndicators();
        } else {
            notify(
                this.$l.UserSettingsPage.UserSettingsComponent.ResultError,
                'error',
                3000
            );
        }
    }

    private async resetOnClick(e: any) {
        const selectedBtn = await this._windowsService!.showDialog(
            this.$l.Dialog.AreYouSure,
            [
                {
                    id: 0,
                    caption: this.$l.UserSettingsPage.Button.Reset,
                },
                {
                    id: -1,
                    caption: this.$l.Button.Cancel,
                },
            ]
        );
        if (selectedBtn >= 0) {
            const result = await this.resetSettings();
            if (result) {
                this.inLoading = true;
                await this.loadData();
                this.inLoading = false;
                notify(
                    this.$l.UserSettingsPage.UserSettingsComponent.ResultSuccess,
                    'success',
                    3000
                );
                await SettingsState.fetchSettings();
                IndicatorsState.fetchIndicators();
            } else {
                notify(
                    this.$l.UserSettingsPage.UserSettingsComponent.ResultError,
                    'error',
                    3000
                );
            }
        }
    }

    private async userChanged(e: any): Promise<void> {
        if (!this.inLoading) {
            this.inLoading = true;
            await this.loadData();
            this.inLoading = false;
        }
    }

    private async roleChanged(e: any): Promise<void> {
        if (!this.inLoading) {
            this.inLoading = true;
            await this.loadData();
            this.inLoading = false;
        }
    }

    private async clientSettingsTreeView_itemSelectionChanged(e: any) {
        if (e.node.itemData.selected === true) {
            this.inLoading = true;
            this.clientSettingType = e.node.itemData.value;
            this.clientSettingId = e.node.itemData.id;
            this.isDropDownBoxOpened = false;
            await this.loadData();
            this.inLoading = false;
        }
    }

    private async setCurrentContextUser(): Promise<void> {
        const currentUser: User = UserState.current!;
        const currentUserId: number = Number(currentUser.id);

        this.currentContextUser = {
            id: currentUserId,
            name: currentUser.name!,
            email: currentUser.email,
            role: this.listUsers.find(u => u.id === currentUserId)?.role,
        };
    }

    private get isDisabled(): boolean {
        return this._isDisabled;
    }

    private async loadSettingsLevel(): Promise<void> {
        this.addClientSetting(
            this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.Summary,
            true,
            -1,
            false
        );
        this.addClientSetting(
            this.$l.UserSettingsPage.UserSettingsComponent.ChangeLevel,
            true,
            undefined,
            true
        );
        this.addClientSetting(
            this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.ContextUser,
            true,
            0,
            false
        );

        // если у контекста есть тип
        if (ContextsState.current!.contextType) {
            this.addClientSetting(
                this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.UserOfContextType,
                true,
                1,
                false
            );
        }

        if (this.isAdmin) {
            this.addClientSetting(
                this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.ContextRole,
                true,
                2,
                false
            );
            this.addClientSetting(
                this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.Context,
                true,
                3,
                false
            );
        }

        if (ContextsState.current!.contextType && this.isAdmin) {
            this.addClientSetting(
                this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.ContextType,
                true,
                4,
                false
            );
        }
    }

    private addClientSetting(
        name: string,
        expanded: boolean,
        value?: number,
        disabled: boolean = false
    ) {
        let currentElementId = 0;
        let parentId: undefined | number;
        if (this.clientSettings.length - 1 >= 0) {
            const lastElementId = this.clientSettings[
                this.clientSettings.length - 1
            ].id;
            currentElementId = lastElementId + 1;
            parentId = lastElementId;
        }

        this.clientSettings.push({
            id: currentElementId,
            value,
            name,
            expanded,
            disabled,
            parentId,
        });
    }

    private async loadData(): Promise<void> {
        let contextSettings: ContextSettings;

        if (this.clientSettingType <= 0) {
            contextSettings = await this.settingsChangeService.fetchSettingsForUser(
                this.selectedUserId.toString()
            );
        } else {
            if (this.clientSettingType === 2) {
                contextSettings = await this.settingsChangeService.fetchSettingsForType(
                    this.clientSettingType,
                    this.listRoles.find(s => s.id === this.selectedRoleId)?.name
                );
            } else {
                contextSettings = await this.settingsChangeService.fetchSettingsForType(
                    this.clientSettingType
                );
            }
        }

        this.localData = new SettingsChangeServiceData(contextSettings);
        this.localData.indicators = contextSettings.indicators;
        this.selectedIndicators = this.checkSelectedIndicators(contextSettings) ?
                                  this.localData.indicators.map(s => new IndicatorItem(s)) : [];

        await this.loadIndicators();

        this.listTableStores = [];
        if (this.clientSettingType === -1) {
            if (contextSettings.settingsTypes) {
                const objectKeys = Object.keys(contextSettings.settingsTypes);
                for (const key of objectKeys) {
                    if (key.includes('layout_')) {
                        const layoutKey = key.replace('layout_', '');
                        this.listTableStores.push({
                            key,
                            name: getTableCaption(layoutKey),
                            type:
                                this.clientSettingType > -1
                                    ? undefined
                                    : this.getSettingType(
                                        contextSettings.settingsTypes[key]
                                    ),
                        });
                    }
                }
            }
        } else {
            if (contextSettings.tableLayouts) {
                const tableKeys = Object.keys(contextSettings.tableLayouts);
                const tableLayoutsName = 'tableLayouts';
                for (const key of tableKeys) {
                    this.listTableStores.push({
                        key,
                        name: getTableCaption(key),
                        type:
                            this.clientSettingType > -1
                                ? undefined
                                : this.getSettingType(
                                    contextSettings.settingsTypes[tableLayoutsName]
                                ),
                    });
                }
            }
        }

        this._isDisabled = false;
        this.inLoading = false;
    }

    private checkSelectedIndicators(contextSettings: ContextSettings): boolean {
        const indicatorsName = 'indicators';
        if (!(this.localData.indicators && this.localData.indicators.length > 0)) {
            return false;
        }

        return this.clientSettingType !== 0 ||
               (this.clientSettingType === 0 &&
                ClientSettingTypeEnum[contextSettings.settingsTypes[indicatorsName]] ===
                ClientSettingTypeEnum[this.clientSettingType]);
    }

    private onDragStart(e: any) {
        e.itemData = e.fromData[e.fromIndex];
    }

    private onAdd(e: any) {
        e.fromData.splice(e.fromIndex, 1);
        e.toData.splice(e.toIndex, 0, e.itemData);
        if (e.element[0].id === 'leftList') {
            this.indicators.push(e.itemData);
        }
    }

    private onRemove(e: any) {
        if (e.element[0].id === 'leftList') {
            this.indicators.splice(this.indicators.indexOf(e.itemData), 1);
        }
    }

    private changed(id: string, value: any): void {
        const finedItem = this.localData.changes.find(s => s.key === id);
        if (!finedItem) {
            const changedSetting: ChangedSetting = {
                key: id,
                value,
            };
            this.localData.changes.push(changedSetting);
        } else {
            finedItem.value = value;
        }
    }

    private tableItemDeleted(e: any) {
        this.localData.forDeleteTableLayouts.push(e.itemData.key);
    }

    private getSettingType(type: ClientSettingTypeEnum): string {
        if (type === undefined) {
            return '';
        } else {
            let result = '';
            switch (type) {
                case ClientSettingTypeEnum.ContextUser:
                    result = this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.ContextUser;
                    break;
                case ClientSettingTypeEnum.UserOfContextType:
                    result = this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.UserOfContextType;
                    break;
                case ClientSettingTypeEnum.ContextRole:
                    result = this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.ContextRole;
                    break;
                case ClientSettingTypeEnum.Context:
                    result = this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.Context;
                    break;
                case ClientSettingTypeEnum.ContextType:
                    result = this.$l.UserSettingsPage.UserSettingsComponent.ClientSettingsType.ContextType;
                    break;
            }
            return result;
        }
    }

    private focusSearch() {
        (this.$refs['indicator-search'] as any).$el.focus();
    }

    private filterIndicators() {
        this.filteredIndicators = this.indicators
            .filter(x => {
                return (
                    x.displayName
                        .toLowerCase()
                        .indexOf(this.localFilter.toLowerCase()) > -1
                );
            })
            .sort((l, r) => {
                return l.displayName < r.displayName ? -1 : 1;
            });
    }

    private async resetSettings(): Promise<boolean> {
        let fetchResult = false;
        const currentResetModel: ResetSettingsModel = new ResetSettingsModel(
            this.clientSettingType
        );

        currentResetModel.settingType = this.clientSettingType;
        currentResetModel.userId = this.selectedUserId.toString();

        if (this.clientSettingType === ClientSettingTypeEnum.ContextRole) {
            currentResetModel.roleName = this.listRoles.find(
                s => s.id === this.selectedRoleId
            )?.name;
            fetchResult = await this.settingsChangeService.resetSettings(
                currentResetModel
            );
        } else {
            fetchResult = await this.settingsChangeService.resetSettings(
                currentResetModel
            );
        }
        return fetchResult;
    }

    private async saveData(): Promise<boolean> {
        let fetchResult = false;
        const currentSaveModel: SaveSettingsRequestModel = new SaveSettingsRequestModel();

        if (this.selectedIndicators.length > 0) {
            currentSaveModel.indicators = this.selectedIndicators.map(
                s => s.name
            );
        }
        currentSaveModel.settingType = this.clientSettingType;
        currentSaveModel.changes = this.localData.changes;
        currentSaveModel.forDeleteGlobals = this.localData.forDeleteGlobals;
        currentSaveModel.forDeleteTableLayouts = this.localData.forDeleteTableLayouts;
        currentSaveModel.userId = this.selectedUserId.toString();

        if (this.clientSettingType === ClientSettingTypeEnum.ContextRole) {
            currentSaveModel.roleName = this.listRoles.find(
                s => s.id === this.selectedRoleId
            )?.name;
            fetchResult = await this.settingsChangeService.save(
                currentSaveModel
            );
        } else {
            fetchResult = await this.settingsChangeService.save(
                currentSaveModel
            );
        }
        return fetchResult;
    }

    private async loadIndicators(): Promise<void> {
        const contextId = ContextsState.currentContextId;
        const url = '/contexts/' + contextId + '/indicator-list';
        const indicatorNames = await this._fetchService!.get<string[]>(url);

        const allIndicators = indicatorNames
            .map(x => new IndicatorItem(x))
            .sort((l, r) => {
                return l.displayName < r.displayName ? -1 : 1;
            });

        this.indicators = allIndicators.filter(x => {
            return !this.selectedIndicators
                .map(m => m.name.toLowerCase())
                .includes(x.name.toLowerCase());
        });

        this.filterIndicators();
    }

    private async loadRoles(): Promise<void> {
        const contextId = ContextsState.currentContextId;
        const url = '/contexts/' + contextId + '/roles';
        this.listRoles = await this._fetchService!.get<Role[]>(url);
    }

    private async loadUsers(): Promise<void> {
        const currentContextId = ContextsState.currentContextId;
        const loadedSettings = await this._fetchService!.get<Array<IUserModel>>(
            '/contexts/' + currentContextId + '/users'
        );
        this.listUsers = loadedSettings;
    }

    @NoCache
    private get settingsChangeService(): SettingsChangeServiceContract {
        return SettingsState.changeService!;
    }
}
